




import { Vue, Component } from 'vue-property-decorator';
import { orderListTypes, focusTabName } from '@/const/order';
import ContentBottom from '@/components/shipping/order/ContentBottom.vue';

@Component({
  components: {
    ContentBottom,
  },
})
export default class OrderList extends Vue {
  private orderListTypes = orderListTypes.ORDER_LIST;
  private orderSearchTypes = focusTabName.DELIVERY_TAB;
}
